<app-navbar></app-navbar>

<ng-container *ngIf="isLinkExpired; else notExpired">
  <div class="page">
    <div class="confirmation-container">
      <mat-icon class="text-danger icon-large">error_outline</mat-icon>
      <h2>{{ 'Link Expired' | translate }}</h2>
      <p>{{ 'Sorry, this link is no longer valid. Please request a new link.' | translate }}</p>
      <button class="dashboard-btn" (click)="toDashboard()">{{ 'Return to Home' | translate }}</button>
    </div>
  </div>
</ng-container>

<ng-template #notExpired>
  <ng-container *ngIf="wentWrong; else successBlock">
    <div class="page">
      <div class="confirmation-container">
        <mat-icon class="text-danger icon-large">error_outline</mat-icon>
        <h2>{{ 'Phone number was not verified' | translate }}</h2>
        <p>{{ 'Something went wrong. Please request a new link.' | translate }}</p>
        <button class="dashboard-btn" (click)="toDashboard()">
          {{ 'Return to Home' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</ng-template>
  
<ng-template #successBlock>
    <div class="page">
      <div class="confirmation-container">
        <mat-icon class="color-primary icon-large">
          check_circle_outline
      </mat-icon>
        <h2>{{'Phone Verified!' | translate}}</h2>
        <p>{{'Thank you for confirming your phone number.' | translate}}</p>
        <button class="dashboard-btn" (click)="toDashboard()">{{'Return to Home' | translate}}</button>
      </div>
    </div>
</ng-template>